import springCenfApi from '../../services/springCenfApi'

export const getVehicleTypes = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/vehicle_types', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)